export function ContractManagementIcon(
  props: React.SVGProps<SVGSVGElement>
): React.ReactElement {
  return (
    <svg
      width="31"
      height="31"
      viewBox="0 0 31 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_18871_16055)">
        <path
          d="M18.1911 25.7981C18.157 25.7937 18.123 25.7847 18.089 25.7757L16.712 25.2771C16.425 25.1739 16.2401 24.9135 16.2548 24.6304L16.3569 23.0406C15.9823 22.7711 15.6368 22.4658 15.3303 22.1289L13.6176 22.2681C13.3111 22.2906 13.0192 22.1334 12.8927 21.8685L12.3186 20.6199C12.197 20.355 12.2748 20.0495 12.5083 19.8609L13.7831 18.792C13.715 18.3429 13.7004 17.8893 13.7344 17.4402L12.4159 16.4207C12.1775 16.2365 12.0948 15.9311 12.2067 15.6617L12.7516 14.3862C12.8635 14.1212 13.1409 13.9505 13.4474 13.9595L15.16 14.0494C15.4519 13.7036 15.7828 13.3847 16.1476 13.0973L15.9969 11.5119C15.9725 11.2245 16.1428 10.955 16.4299 10.8382L17.7775 10.3038C18.0646 10.1915 18.3955 10.2633 18.5999 10.4789L19.7529 11.6601C20.2249 11.5972 20.7065 11.5792 21.1834 11.6152L22.2926 10.3891C22.4921 10.169 22.823 10.0882 23.11 10.196L24.4869 10.6945C24.774 10.7978 24.954 11.0583 24.9443 11.3412L24.8421 12.9311C25.2168 13.205 25.5621 13.5105 25.8688 13.8518L27.5814 13.7125C27.8879 13.6856 28.1798 13.8473 28.3063 14.1123L28.8804 15.3608C29.002 15.6258 28.9241 15.9311 28.6906 16.1198L27.4159 17.1887C27.4743 17.6243 27.4791 18.069 27.4403 18.509L28.7831 19.5376C29.0215 19.7172 29.109 20.0225 29.002 20.2921L28.462 21.5675C28.35 21.8325 28.0679 22.0031 27.7663 21.9942L26.0536 21.9043C25.7568 22.2546 25.4163 22.5736 25.0465 22.861L25.1973 24.4464C25.2216 24.7338 25.0514 25.0032 24.7691 25.1155L23.4214 25.65C23.1344 25.7622 22.8035 25.6903 22.5991 25.4748L21.4461 24.2936C20.9693 24.3565 20.4876 24.3745 20.0108 24.343L18.9064 25.5646C18.736 25.7577 18.4636 25.8431 18.2009 25.7892L18.1911 25.7981Z"
          stroke="#A15FF6"
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <path
          d="M19.7821 21.2666C19.607 21.2307 19.4367 21.1813 19.2712 21.1184C17.4662 20.4582 16.5515 18.5899 17.2035 16.8922C17.8555 15.1946 19.8356 14.2784 21.6845 14.8174C23.5333 15.3562 24.5988 17.1483 24.0879 18.8863C23.5771 20.6198 21.6747 21.6753 19.7821 21.2666Z"
          stroke="#A15FF6"
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <path
          d="M20.5991 27.1634C20.5991 28.3671 19.5433 29.3461 18.2345 29.3461H4.20271C2.89878 29.3461 1.83813 28.3716 1.83813 27.1634V3.83649C1.83813 2.63287 2.89392 1.65381 4.20271 1.65381H18.2345C19.5384 1.65381 20.5991 2.62838 20.5991 3.83649V8.01774"
          stroke="#A15FF6"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.4873 5.46692H16.9599"
          stroke="#A15FF6"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.4873 9.00134H13.1211"
          stroke="#A15FF6"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.4873 12.0599H11.3842"
          stroke="#A15FF6"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_18871_16055">
          <rect
            width="30"
            height="30"
            fill="white"
            transform="translate(0.588135 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
